import { apiClient, extractData, extractList } from '../../lib/api-client.js';

export interface Task {
  taskId: string;
  userId: string;
  listId: string;
  title: string;
  note?: string;
  priority: 'high' | 'medium' | 'low';
  dueDate?: string;
  done: boolean;
  createdAt: number;
  completedAt: number | null;
  updatedAt: number;
  parentTaskId?: string;
  sortOrder?: number;
}

export interface CreateTaskPayload {
  title: string;
  listId: string;
  note?: string;
  priority?: 'high' | 'medium' | 'low';
  dueDate?: string;
  parentTaskId?: string;
}

export interface UpdateTaskPayload {
  title?: string;
  listId?: string;
  note?: string | null;
  priority?: 'high' | 'medium' | 'low';
  dueDate?: string | null;
  done?: boolean;
  sortOrder?: number;
}

export async function fetchTasks(params?: {
  listId?: string;
  priority?: string;
  status?: string;
  parentTaskId?: string;
}): Promise<Task[]> {
  const res = await apiClient.get('/v1/tasks', { params });
  return extractList<Task>(res);
}

export async function fetchTask(taskId: string): Promise<Task> {
  const res = await apiClient.get(`/v1/tasks/${taskId}`);
  return extractData<Task>(res);
}

export async function createTask(payload: CreateTaskPayload): Promise<Task> {
  const res = await apiClient.post('/v1/tasks', payload);
  return extractData<Task>(res);
}

export async function updateTask(taskId: string, payload: UpdateTaskPayload): Promise<Task> {
  const res = await apiClient.put(`/v1/tasks/${taskId}`, payload);
  return extractData<Task>(res);
}

export async function deleteTask(taskId: string): Promise<void> {
  await apiClient.delete(`/v1/tasks/${taskId}`);
}
